import React from 'react';

import UserIdentity from '../../../shared/components/UserIdentity';

interface UserCellProps {
    name?: string | undefined;
    email?: string | undefined;
    avatar?: string | undefined;
    initialsBgColor?: string | undefined;
    initialsTextColor?: string | undefined;
}

const UserCell: React.FC<UserCellProps> = ({
    name,
    email,
    avatar,
    initialsBgColor = 'bg-primary/10',
    initialsTextColor = 'text-primary',
}) => {
    const identityProps = {
        initialsBgColor,
        initialsTextColor,
    } as {
        initialsBgColor: string;
        initialsTextColor: string;
        name?: string;
        email?: string;
        avatarUrl?: string;
    };

    if (typeof name === 'string' && name.trim()) {
        identityProps.name = name;
    }
    if (typeof email === 'string' && email.trim()) {
        identityProps.email = email;
    }
    if (typeof avatar === 'string' && avatar.trim()) {
        identityProps.avatarUrl = avatar;
    }

    return (
        <UserIdentity {...identityProps} />
    );
};

export default UserCell;
